import React, { useState, useEffect } from 'react';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';
import './theme/_main.scss';
import FadeInSection from '../../customizations/components/theme/Animations/FadeInSection';
import Slider from 'react-slick';

const View = (props) => {
  const { data, isEditMode } = props;
  const [activateSlider, setActivateSlider] = useState(false);
  const [groups, setGroups] = useState([]);
  const [windowWidth, setWindowWidth] = useState(undefined);

  if (!data) {
    return <div>missing data</div>;
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowWidth(window.innerWidth);
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    if (data.elems?.length > Number(data.anzahl)) {
      setActivateSlider(true);
    } else {
      setActivateSlider(false);
    }
  }, [data]);

  useEffect(() => {
    const tmp = [];
    let interval = Number(data.anzahl);
    if (windowWidth < 1000) interval = Math.min(interval, 3);
    if (windowWidth < 700) interval = 1;

    if (!data.elems) return;
    for (let i = 0; i < data.elems.length; i += interval) {
      tmp.push(data.elems.slice(i, i + interval));
    }
    setGroups(tmp);
  }, [data.anzahl, windowWidth]);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const SponsorLogo = ({ elem, index }) => (
    <ConditionalLink key={index} to={flattenToAppURL(elem.link)} condition={!isEditMode}>
      <div className="tile" tabIndex={!isEditMode ? 0 : undefined}>
        {elem.image && (
          <>
            <Image
              src={flattenToAppURL(elem.image['@id'] + '/@@images/image/preview')}
              alt={elem.alt ? `Sponsor: ${elem.alt}` : 'Sponsor Logo'}
            />
            {elem.alt && <span className="sr-only">{elem.alt}</span>}
          </>
        )}
      </div>
    </ConditionalLink>
  );

  const SliderContent = () => (
    <div className="full-width sponsoren-bereich custom-block" role="region" aria-label="Sponsorenliste">
      <Slider {...settings}>
        {groups?.map((elem, index) => (
          <div
            key={`slide-${index}`}
            className="q container layout"
            role="group"
            aria-roledescription="slide"
            aria-label={`Slide ${index + 1} von ${groups.length}`}
          >
            <div className="sponsoren-container">
              {elem.map((icon, idx) => (
                <SponsorLogo key={idx} elem={icon} index={idx} />
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );

  const StaticContent = () => (
    <div className="full-width sponsoren-bereich custom-block" role="region" aria-label="Sponsorenliste">
      <div className="q container layout">
        <div className="sponsoren-container">
          {data.elems?.map((elem, index) => (
            <SponsorLogo key={index} elem={elem} index={index} />
          ))}
        </div>
      </div>
    </div>
  );

  return <FadeInSection>{activateSlider ? <SliderContent /> : <StaticContent />}</FadeInSection>;
};

export default View;
